
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopuneairporttaxi() {



    const cardData =
    {
        keyword: 'Pune to Pune Airport Taxi',
        heading: 'Platinum24 Cabs: Pune to Pune Airport Taxi',
        headingDescription: ' Platinum24 Cabs provides reliable Pune to Pune Airport Taxi services, ensuring safe, punctual, and hassle-free transfers to Pune International Airport. Our fleet of hatchbacks, sedans, SUVs, and luxury cars is available 24/7, offering convenient travel for solo passengers, families, and corporate clients. With professional chauffeurs, on-time pickups, and transparent fares, we make airport transfers smooth and stress-free. Whether it’s an early morning drop, late-night pickup, or regular business commute, Platinum24 Cabs guarantees affordable pricing, clean vehicles, and dependable service for your Pune to Pune Airport travel.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was the grand seat of the Peshwas of the Maratha Empire. Its mighty gates, fountains, and sprawling courtyards narrate tales of Bajirao and Mastani. Although partially destroyed by fire in 1828, the ruins still showcase Maratha pride. The evening light-and-sound show recreates historical glory. History lovers and tourists are drawn to its corridors and gardens. Shaniwar Wada is Pune’s proud symbol of heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it houses a museum displaying Gandhi’s belongings and photographs. Its Italian arches and sprawling gardens add elegance. It is also the memorial site of Kasturba Gandhi. Aga Khan Palace is Pune’s historic gem of peace and inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is remembered for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The hilltop fort offers panoramic views of the Sahyadris and trekking trails. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon brings mist and waterfalls, enhancing the experience. Local villagers serve traditional pithla-bhakri at the summit. Sinhagad is Pune’s blend of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, richly decorated with gold, attracts lakhs of devotees. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also renowned for its social and charitable works. The temple’s spiritual aura draws both locals and tourists. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city’s center, it provides peace and spirituality. Evening prayers add a mystical touch. Its ancient rock carvings reflect early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage temple."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure with over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include musical instruments, ornaments, sculptures, and everyday antiques. The recreated Mastani Mahal is a major attraction. Students and history enthusiasts find it highly educational. The museum preserves India’s cultural legacy. It is Pune’s proud showcase of heritage and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers breathtaking views of the city. The hilltop temple complex is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum enrich its heritage value. Sunsets and sunrises are especially mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "Osho International Meditation Resort in Koregaon Park is a world-renowned center for spirituality and wellness. Spread across lush gardens, it offers meditation, yoga, and therapy programs. Its Zen gardens and modern lifestyle blend attract seekers worldwide. Visitors experience relaxation, rejuvenation, and inner peace. It is Pune’s global destination for mindfulness. Osho Ashram is the city’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features streams, stone bridges, and beautifully manicured lawns. Families enjoy walks, picnics, and photography here. Seasonal flowers and lush greenery make it picturesque year-round. It symbolizes Indo-Japanese friendship. Pu La Deshpande Garden is Pune’s green paradise of calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend spot near Pune. It provides water to the city and scenic landscapes for visitors. Monsoon makes it especially beautiful with overflowing streams. Vendors selling hot corn and tea add to the charm. It is also the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


   "services": [
    {
      "name": "Pune to Pune Airport Taxi Service",
      "description": "Experience seamless and stress-free travel with our Pune to Pune Airport Taxi Service. Whether you are catching a flight or arriving in Pune, our reliable taxis ensure timely pickups and drop-offs, equipped with comfortable vehicles and professional drivers who prioritize your convenience and safety."
    },
    {
      "name": "Pune Airport Pickup Taxi",
      "description": "Our Pune Airport Pickup Taxi service offers prompt and courteous drivers who track your flight to provide timely airport arrivals. Enjoy hassle-free transportation from Pune Airport to your home, hotel, or office with clean, well-maintained cars available at competitive rates."
    },
    {
      "name": "Pune Airport Drop Taxi",
      "description": "Get to the airport on time and without worry using our Pune Airport Drop Taxi service. Whether it’s an early morning flight or a late-night journey, our experienced drivers ensure punctual drop-offs and a comfortable ride in modern vehicles."
    },
    {
      "name": "Airport Transfer Pune",
      "description": "Reliable and efficient Airport Transfer services in Pune are just a booking away. Our dedicated fleet caters to both pickups and drop-offs, providing you with convenient travel options that save time and eliminate the stress of last-minute transport arrangements."
    },
    {
      "name": "Affordable Airport Taxi Pune",
      "description": "Travel to and from Pune Airport without stretching your budget. Our Affordable Airport Taxi Pune service combines cost-effective rates with quality service, ensuring you get great value for money along with safe and comfortable rides."
    },
    {
      "name": "Pune Airport Taxi with Driver",
      "description": "Enjoy the luxury of having a professional driver for your airport transfers. Our Pune Airport Taxi with Driver service guarantees courteous chauffeurs who are familiar with the best routes, ensuring smooth and timely journeys to or from Pune Airport."
    },
    {
      "name": "Pune Airport Taxi Booking",
      "description": "Book your Pune Airport Taxi effortlessly through our online or phone booking system. Our user-friendly platform allows you to schedule your airport transfer in advance, with instant confirmations and 24/7 customer support to assist you anytime."
    },
    {
      "name": "Pune Airport Cab Rental",
      "description": "Looking for a cab rental for airport trips? Our Pune Airport Cab Rental service offers flexible packages for hourly or full-day rentals with professional drivers, perfect for business travelers, families, and groups needing reliable airport transport."
    },
    {
      "name": "Pune Airport Taxi Charges",
      "description": "Get transparent and competitive Pune Airport Taxi Charges with no hidden fees. Our pricing is designed to offer affordability while maintaining the highest standards of service, ensuring you know exactly what you pay for your airport transfers."
    },
    {
      "name": "Pune Airport Taxi Service 24x7",
      "description": "No matter your flight time, our Pune Airport Taxi Service is available 24x7 to provide you with dependable airport transportation. Day or night, our drivers are ready to serve you with punctuality, professionalism, and safety."
    },
    {
      "name": "Pune Airport Shuttle Service",
      "description": "For group travel and budget-conscious passengers, our Pune Airport Shuttle Service offers shared rides to and from the airport. Enjoy convenient shuttle timings and affordable rates without compromising on comfort or reliability."
    },
    {
      "name": "Pune Local to Airport Taxi",
      "description": "Travel from anywhere in Pune to the airport with ease using our Pune Local to Airport Taxi service. We cover all local areas with timely pickups, ensuring you reach the airport relaxed and on schedule."
    },
    {
      "name": "Pune Airport Taxi Deals",
      "description": "Take advantage of special Pune Airport Taxi Deals that offer discounted rates and promotional offers on airport transfers. Book with us to enjoy premium service at budget-friendly prices."
    },
    {
      "name": "Pune Airport Private Taxi",
      "description": "Opt for privacy and exclusivity with our Pune Airport Private Taxi service. Perfect for VIP travelers and those who prefer a dedicated vehicle, our private taxis provide personalized service tailored to your schedule and preferences."
    },
    {
      "name": "Pune Airport Taxi Service Near Me",
      "description": "Find the nearest Pune Airport Taxi Service with ease. Our extensive network ensures quick dispatch and prompt arrival, making your airport transfer experience smooth and hassle-free regardless of your location in Pune."
    }
  ],
  "tableData": [
    ["Pune to Pune Airport Taxi Service", "Pune Airport Pickup Taxi"],
    ["Pune Airport Drop Taxi", "Airport Transfer Pune"],
    ["Affordable Airport Taxi Pune", "Pune Airport Taxi with Driver"],
    ["Pune Airport Taxi Booking", "Pune Airport Cab Rental"],
    ["Pune Airport Taxi Charges", "Pune Airport Taxi Service 24x7"],
    ["Pune Airport Shuttle Service", "Pune Local to Airport Taxi"],
    ["Pune Airport Taxi Deals", "Pune Airport Private Taxi"],
    ["Pune Airport Taxi Service Near Me", "—"]
  ],


           "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Pune Airport Taxi Service",
      "WhyChoosedescription": "Platinum24 Cabs offers timely and comfortable taxi services from Pune to Pune Airport for a stress-free travel experience."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Airport Routes",
      "WhyChoosedescription": "Our skilled drivers know the best routes to ensure you reach Pune Airport on time."
    },
    {
      "WhyChooseheading": "Clean and Air-Conditioned Vehicles",
      "WhyChoosedescription": "Travel in sanitized, comfortable cabs equipped with air conditioning for a pleasant ride."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Choose from convenient packages to suit your airport transfer needs."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront fares inclusive of fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
      "WhyChoosedescription": "Our dedicated team is available round the clock to assist with bookings and inquiries."
    },
    {
      "WhyChooseheading": "Ideal for Business and Leisure Travelers",
      "WhyChoosedescription": "Perfect for all travelers seeking reliable airport transfers in Pune."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options Available",
      "WhyChoosedescription": "Choose from sedans, SUVs, or larger vehicles based on your luggage and comfort requirements."
    }
  ]


























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide taxi services from Pune to Pune Airport?',
        answer: 'Yes, Platinum24 Cabs offers reliable and timely taxi services for travel between Pune city and Pune Airport.',
    },
    {
        question: 'How can I book a taxi from Pune to Pune Airport with Platinum24 Cabs?',
        answer: 'You can book your Pune to Pune Airport taxi easily through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Pune Airport trips?',
        answer: 'We offer a range of vehicles including sedans, SUVs, and premium cars to suit your comfort and luggage requirements.',
    },
    {
        question: 'Are the drivers experienced with airport transfers in Pune?',
        answer: 'Yes, our drivers are professional, punctual, and knowledgeable about Pune city and airport routes to ensure timely pickups and drop-offs.',
    },
    {
        question: 'Can I book a taxi for one-way or round-trip airport transfers?',
        answer: 'Absolutely! We provide both one-way and round-trip taxi services for Pune Airport transfers with flexible scheduling.',
    },
    {
        question: 'What is included in the fare for Pune to Pune Airport taxi services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for waiting time or extra stops.',
    },
    {
        question: 'Can I customize pickup location within Pune for airport taxi service?',
        answer: 'Yes, you can specify any pickup location within Pune for your airport taxi service.',
    },
    {
        question: 'Are safety measures followed for Pune Airport taxi rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols to ensure your protection.',
    },
    {
        question: 'Is it possible to book an airport taxi for early morning or late-night flights?',
        answer: 'Yes, our Pune to Pune Airport taxi services are available 24x7 to accommodate your flight timings.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate airport taxi services?',
        answer: 'Yes, we offer customized corporate airport transfer solutions with priority support and flexible billing.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rajesh Shinde',
        feedback: 'The taxi service from Pune to Pune Airport was punctual and comfortable. Highly recommend Platinum24 Cabs!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya More',
        feedback: 'Booked a Pune Airport taxi with Platinum24 Cabs, and the experience was smooth with a professional driver.',
        rating: 5,
    },
];




























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];





const puneAirportTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable Pune to Pune Airport Taxi Service offering airport pickups, drop-offs, affordable taxi rentals with driver, 24x7 airport shuttle, and private cab services.",
  "areaServed": {
    "@type": "Place",
    "name": "Pune"
  },
  "serviceType": [
    "Pune to Pune Airport Taxi Service",
    "Pune Airport Pickup Taxi",
    "Pune Airport Drop Taxi",
    "Airport Transfer Pune",
    "Affordable Airport Taxi Pune",
    "Pune Airport Taxi with Driver",
    "Pune Airport Taxi Booking",
    "Pune Airport Cab Rental",
    "Pune Airport Taxi Charges",
    "Pune Airport Taxi Service 24x7",
    "Pune Airport Shuttle Service",
    "Pune Local to Airport Taxi",
    "Pune Airport Taxi Deals",
    "Pune Airport Private Taxi",
    "Pune Airport Taxi Service Near Me"
  ],
  "telephone": "+91-XXXXXXXXXX"
};









    return (
        <div>

<Helmet>
  <title>Pune to Pune Airport Taxi Service | Airport Pickup & Drop Pune</title>
  <meta
    name="description"
    content="Reliable Pune to Pune Airport Taxi Service offering airport pickups, drop-offs, affordable taxi rentals with driver, 24x7 airport shuttle, and private cab services."
  />
  <meta
    name="keywords"
    content="Pune to Pune Airport Taxi Service, Pune Airport Pickup Taxi, Pune Airport Drop Taxi, Airport Transfer Pune, Affordable Airport Taxi Pune, Pune Airport Taxi with Driver, Pune Airport Taxi Booking, Pune Airport Cab Rental, Pune Airport Taxi Charges, Pune Airport Taxi Service 24x7, Pune Airport Shuttle Service, Pune Local to Airport Taxi, Pune Airport Taxi Deals, Pune Airport Private Taxi, Pune Airport Taxi Service Near Me"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneAirportTaxiSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/67.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetopuneairporttaxi;